import { Component, OnInit } from '@angular/core';
import {RestService} from '../shared/rest/rest.service';

@Component({
  selector: 'app-version-info',
  templateUrl: './version-info.component.html',
  styleUrls: ['./version-info.component.scss']
})
export class VersionInfoComponent implements OnInit {

  public versionInfo: string;

  public frameworkVersionsInfo: string;

  constructor(private rest: RestService) {
  }

  ngOnInit() {
    this.getVersionInfo();
  }

  getFullVersionInfo() {
    return ['auth-service: ' + this.versionInfo, this.frameworkVersionsInfo].join(", ");
  }

  getVersionInfo() {
    this.rest.getVersion()
        .subscribe((value: any) => {
          this.versionInfo = this.parseInfo(value);
        });

    this.rest.getFrameworksVersions()
      .subscribe((values) => {
        this.frameworkVersionsInfo  = values.map( v => v.domain + ': ' + this.parseInfo(JSON.parse(v.gitInfo))).join(', ')
      }, error => {
        console.debug('Unable to get framework version info', error);
        this.frameworkVersionsInfo = '';
      })
  }

  private parseInfo(value) {
    const date = new Date(value['git.build.time']);
    return value['git.build.version'] + '_' + value['git.commit.id.abbrev'] + ' (' + date.toLocaleString() + ')';
  }
}
